var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecuredMagicBoxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09305 5.10173L7.12669 5.08442L7.15842 5.06382L10.5 2.89422L13.8416 5.06382L13.8733 5.08442L13.9069 5.10173L17.25 6.82126V7.21784C17.25 11.6194 14.5684 15.566 10.5 17.1962C6.43158 15.566 3.75 11.6194 3.75 7.21784V6.82126L7.09305 5.10173Z",
    stroke: "#585D66",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.485 7.66054L9.69091 11.4568L7.79182 9.55829",
    stroke: "#585D66",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecuredMagicBoxIcon);
export default __webpack_public_path__ + "static/media/secured-magic-box-icon.1ecb226c04c8004e3cb75b6e1c6acd1c.svg";
export { ForwardRef as ReactComponent };